module.exports = __webpack_public_path__ + "static/perlin_bleed-0ad87380a268ef5aa88940db0d396371.gif";